/*
 * @Description: 退出
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { eContract, projectSettled } from '@/api/ajax';

const example = new TableRenderClass({ fields, search });

const part = example.createPart({
  name: '项目退出',
  search: [
    'projectName',
    'userName',
    'projectStructureType',
    'phone',
    'auditStatus'
  ],
  list: projectSettled.projectSettledOutList,
  requestNow: true,
  fields: [
    'index',
    'userName',
    'phone',
    'zooidEnterpriseName',
    'projectName',
    'createDt',
    'toReCord',
    'auditStatus',
    'exitHandler'
  ]
});

export const exit = part;
